export const styles = {
  blockHeading: {
    fontSize: '36px',
    fontWeight: 600,
    lineHeight: '54px',
    color: '#101828',
    pb: '40px',
    pt: '60px',
    textAlign: 'center'
  },
  container: {
    gap: '24px',
    flexDirection: ['row', 'column', 'column', 'column', 'row'],
    pb: '60px'
  },
  appItem: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    padding: '40px',
    borderRadius: '20px',
    backgroundColor: '#F0F9FF',
  },
  header: {
    gap: '12px',
    mb: '12px',
  },
  heading: {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: '600',
    color: '#101828',
    margin: '0',
  },
  textItemContainer: {
    flexDirection: 'column',
  },
  textItem: {
    gap: '12px',
    alignItems: 'flex-start',
  },
  textStyles: {
    fontSize: ['18px', '16px', '16px', '18px', '18px', '18px'],
    lineHeight: ['28px', '24px', '24px', '28px', '28px', '28px'],
    fontWeight: '400',
    color: '#475467',
    margin: '0',
  },
  imagesWrapper: {
    mt: '20px',
    mx: 'auto',
  },
  storeButtonsWrapper: {
    justifyContent: 'center',
    gap: '16px',
    mt: '24px',
  },
  buttonsWrapperStyles: {
    mx: 'auto',
    mt: '24px',
  },
};
